import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import SettingsSidebar from "../../layouts/SettingsSidebar";
import { Form, Field } from "react-final-form";
import { useEffect, useState } from "react";
import alertify from "alertifyjs";
import PhoneInput from "react-phone-number-input";

const AccountSettings = () => {
  const user = window.CURRENT_USER;
  const [initialValues, setInitialValues] = useState();

  useEffect(() => {
    fetch(`/accounts/users/${user.id}/${user.user_role}/`)
      .then((res) => res.json())
      .then((data) => {
        setInitialValues(data);
        console.log("Fetched user data:", data);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }, []);
  const required = (value) => (value ? undefined : "Required");

  const onSubmit = (values) => {
    fetch(`/accounts/users/${user.id}/${user.user_role}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
      body: JSON.stringify(values),
    })
      .then((res) => {
        if (res.status === 200) {
          window.location.reload();
        } else {
          alertify.error("Failed to update account settings");
          alertify.error(
            "Something went wrong. Please check with the administrator"
          );
        }
        return res.json();
      })
      .catch(() => {
        alertify.error("Something went wrong");
      });
  };

  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingsSidebar />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="card">
                <div className="card-body w-100">
                  <div className="content-page-header">
                    <h5 className="setting-menu">Account Settings</h5>
                  </div>
                  {initialValues && (
                    <Form
                      onSubmit={onSubmit}
                      initialValues={initialValues}
                      render={({ handleSubmit, submitting, pristine }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-title">
                                <h5>General Information</h5>
                              </div>
                            </div>
                            <div className="col-lg-6 col-12">
                              <div className="input-block mb-3">
                                <label>Name</label>
                                <Field
                                  name="full_name"
                                  component="input"
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-12">
                              <div className="input-block mb-3">
                                <label>Email</label>
                                <Field
                                  name="email"
                                  component="input"
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter Email Address"
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-12">
                              <div className="input-block mb-3">
                                <label>Mobile Number</label>

                                <Field name="mobile_number" validate={required}>
                                  {({ input, meta }) => (
                                    <>
                                      <PhoneInput
                                        defaultCountry="IN"
                                        value={input.value}
                                        onChange={input.onChange}
                                        placeholder="Enter Phone Number"
                                        className="input-block form-control"
                                        style={{
                                          display: "flex",
                                        }}
                                      />
                                      {meta.touched && meta.error && (
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {meta.error}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </Field>
                              </div>
                            </div>
                            <div className="col-lg-6 col-12">
                              <div className="input-block mb-3">
                                <label>Password</label>
                                <Field
                                  name="password"
                                  component="input"
                                  type="password"
                                  className="form-control"
                                  placeholder="Enter Password only if you want to update password"
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="btn-path text-end">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  disabled={submitting || pristine}
                                >
                                  Save Changes
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
